export const DEFAULT_ROWS_OPTIONS = [10, 25, 50, 100];
export const ELLIPSIS = '...' as const;

export const MAX_VISIBLE_PAGES = 5;
export const NEAR_EDGE_THRESHOLD = 3;
export const NEAR_EDGE_OFFSET = 2;

export interface PaginationProps {
  totalPages: number;
  rowsPerPageOptions?: number[];
}
